export class ChatApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message)
    this.name = 'ChatApiError'
  }
}

export async function checkChatResponse(response: Response): Promise<void> {
  if (response.ok) return
  const body = await response.json().catch(() => null)
  throw new ChatApiError(
    response.status,
    typeof body?.detail === 'string' ? body.detail : `HTTP ${response.status}`,
  )
}
